/* eslint-disable react/no-danger */
import React from 'react';
import _get from 'lodash.get';
import { isApp } from 'utils/getParams';
import {
  loadLayoutData,
  loadLayoutDataTOIP,
  loadCommonData,
} from 'reduxUtils/modules_v2/layout';
import {
  getAtfFanAdCode,
  getFbnFanAdCode,
  setAdsConfig,
  processAdsCaimpaigns,
} from 'helpers/ads/utils';
import { updatePrebidFlag } from 'helpers/ads/redux';
import {
  getSiteConfig,
  updateCaimpaignAdsConfig,
} from 'reduxUtils/modules/common';
// import AdCaller from 'helpers/ads/adCaller';
import {
  commonHeadScriptsMobile,
  commonHeadScripts,
} from 'helpers/scripts/headScripts';
import { gptHeadAppendScript } from 'helpers/ads/constants';
import { adRecoverScriptString } from 'routes/articleshow/utils/adRecover';
import { setValue } from 'routes/articleshow/utils/ctnTargeting';
import Layout from 'components_v2/desktop/ETimesLayout';
import InfocusList from 'components_v2/desktop/InfocusList';
import {
  loadArticleshowData,
  updateActiveMsid,
} from 'routes/articleshow_v2/redux';
import { getGAData } from 'routes/articleshow/utils/getGAData';
import { getActiveCfmid } from 'reduxUtils/modules_v2/header';
import {
  getSectionsListFromBreadCrumb,
  getCustomDimension8,
  setCacheTime,
  fireGA4Script,
} from 'utils/common';
import { loadPageAdCode } from 'helpers/ads/revenueRedux';
import {
  STAGING_URL_PREFIX2,
  TOI_LIVE_DOMAIN,
  ARTICLESHOW,
  TOI_INSTAGRAM_EMBED_JS,
  DESKTOP_PLATFORM,
  BUSINESS_ETIMES,
  WEBVIEW_PLATFORM,
} from '../../../../constants';
import s from '../desktop/Articleshow_v2.scss';
import { implementExperiment } from '../../../../utils/primeUtil';
import Articleshow from '../desktop/Articleshow';
import isExperimentEnabled from '../../utils/isExperimentEnabled';
import getGa4PageViewEventObj from '../../utils/getGa4PageViewEventObj';
import getCwvReportingObj from '../../utils/getCwvReportingObj';

const pageName = 'articleshow_v2_etimesdesktop';

async function action(context, params) {
  const dataPromiseArray = [];
  const isAppView = isApp(context.query);
  const isBrowser = typeof window === 'object';
  const isServer = typeof window === 'undefined';
  const isWapView = false;
  let isPrime = false;
  let showMiniTv = true;
  let hideAdCude = false;
  let leadImageHref = '';
  const { pathname } = context;

  const isCryptoCurrencyArticle =
    pathname && pathname.includes('/cryptocurrency/');

  // existing state
  // eslint-disable-next-line one-var
  let state = context.store.getState();

  const newParams = {
    ...params,
    // fullPath: context.path,
    fullPath: `/articleshow/${params.msid}.cms`,
    isWapView,
    isAppView,
    skipSubSections: false,
    isClientConsumable: context.query.test === 'consumable',
    frmprime: state.isPrime ? 'yes' : '',
  };

  let showPreload;
  const imageInfo = [];

  if (!state.articleshow_v2.data) {
    dataPromiseArray.push(
      context.store.dispatch(loadArticleshowData(newParams, isAppView)),
    );
  }

  if (isAppView && !state.sidebar.data) {
    dataPromiseArray.push(
      //passing template name/ resolved routes to feed instead of entire articleshow path
      context.store.dispatch(loadCommonData(newParams, 'articleshow')),
    );
  } else if (
    !isAppView &&
    (!state.header.data || !state.footer_v2.data || !state.sidebar.data)
  ) {
    dataPromiseArray.push(context.store.dispatch(loadLayoutData(newParams)));
  }
  if (typeof window === 'undefined') {
    dataPromiseArray.push(context.store.dispatch(getSiteConfig()));
  }

  // wait for responses on server side
  if (typeof window === 'undefined') {
    await Promise.all(dataPromiseArray);
    context.store.dispatch(updateActiveMsid(params.msid));
  }
  state = context.store.getState();

  let status = 200;
  let redirect = false;
  let title = 'Get Latest News Updates from Times Of India';
  let dataAvailable =
    state.articleshow_v2 &&
    state.articleshow_v2.data &&
    state.articleshow_v2.data[params.msid];

  const forcedErrorStatus =
    state.articleshow_v2 && state.articleshow_v2.forcedErrorStatus
      ? state.articleshow_v2.forcedErrorStatus
      : null;

  if (isServer && !dataAvailable) {
    status = 404;
  }
  if (
    state &&
    state.articleshow_v2 &&
    state.articleshow_v2.data &&
    state.articleshow_v2.data.undefined &&
    state.articleshow_v2.data.undefined.redirectUrl
  ) {
    status = 301;
    redirect = state.articleshow_v2.data.undefined.redirectUrl;
  }
  if (forcedErrorStatus) {
    status = forcedErrorStatus;
    dataAvailable = false;
  }

  let isInstaEmbeds = false;

  const checkInstaEmbeds = () => {
    const { articleshow_v2: { data = {} } = {} } = state;
    const articleData = data[[params.msid]] || {};
    if (!articleData || !articleData.story) {
      return false;
    }
    const instaEmbeds = articleData.story.filter(
      item => item.tn === 'cdata' && item.type === 'instagram',
    );
    return instaEmbeds && Array.isArray(instaEmbeds) && instaEmbeds.length > 0;
  };

  const isSpotlight = () => {
    const { articleshow_v2: { data = {} } = {} } = state;
    const articleData = data[[params.msid]] || {};
    const { ag: articleAgencyName } = articleData;
    const { navsubsecs: { subsec2: { subsecmsid2 } = {} } = {} } = articleData;
    return (
      articleAgencyName === 'SPOTLIGHT' ||
      articleAgencyName === 'Spotlight Wire' ||
      subsecmsid2 === '6590699' ||
      subsecmsid2 === '63710536' ||
      params.msid === '108210513'
    );
  };
  const isSPOTLIGHTArticle = isSpotlight();

  if (dataAvailable) {
    title = state.articleshow_v2.data[params.msid].seo
      ? state.articleshow_v2.data[params.msid].seo.title
      : '';
    isPrime =
      state.articleshow_v2.data[params.msid].cs &&
      state.articleshow_v2.data[params.msid].cs.toLowerCase() === 'prime';
    if (
      state.articleshow_v2.data[params.msid].filters &&
      state.articleshow_v2.data[params.msid].filters.length > 0
    ) {
      context.store.dispatch(
        getActiveCfmid(state.articleshow_v2.data[params.msid].filters[0].cfmid),
      );
    }
    if (typeof window === 'undefined' && isPrime) {
      await context.store.dispatch(loadLayoutDataTOIP(newParams));
      state = context.store.getState();
    }

    const articleShowData = state?.articleshow_v2?.data[params.msid];

    let leadImgId =
      articleShowData &&
      Array.isArray(articleShowData.images) &&
      articleShowData.images.length &&
      articleShowData.images[0] &&
      articleShowData.images[0].id;

    let imgsize =
      articleShowData &&
      Array.isArray(articleShowData.images) &&
      articleShowData.images.length &&
      articleShowData.images[0] &&
      (articleShowData.images[0].imgsize ||
        articleShowData.images[0].imagesize);

    if (
      articleShowData &&
      Array.isArray(articleShowData.videos) &&
      articleShowData.videos[0]
    ) {
      leadImgId = articleShowData.videos[0].id;
      imgsize = articleShowData.videos[0].imageid
        ? articleShowData.videos[0].imageid.split('&imgsize=')[1]
        : '12345';
    }
    leadImageHref = `https://static.toiimg.com/thumb/msid-${leadImgId},${
      imgsize ? `imgsize-${imgsize}` : ''
    },width-400,resizemode-4/${leadImgId}.jpg`;

    if (leadImgId) {
      imageInfo.push(leadImageHref);
    }

    showPreload = imageInfo instanceof Array && imageInfo.length > 0;
    if (!isPrime) {
      isInstaEmbeds = checkInstaEmbeds();
    }
  }

  if (
    isBrowser &&
    dataAvailable &&
    state.articleshow_v2.data[params.msid].seo
  ) {
    let canonicalUrl = state.articleshow_v2.data[params.msid].seo.canonical;
    if (typeof canonicalUrl === 'string') {
      const businessUsageType =
        state?.articleshow_v2?.data[params.msid]?.metaInfo?.BusinessUsageType;
      const isTOISpecialPage =
        businessUsageType && businessUsageType === 'Special Page';
      if (isTOISpecialPage) {
        canonicalUrl = canonicalUrl.replace('/articleshow/', '/featureshow/');
      }
    }
    if (
      canonicalUrl &&
      canonicalUrl.indexOf('timesofindia.indiatimes.com') > -1 &&
      //window.location.href.indexOf('?') === -1 &&
      state.articleshow_v2.data[params.msid].multipublish !== 1
    ) {
      canonicalUrl = canonicalUrl.split('timesofindia.indiatimes.com');
      const urlInBrowser = window.location.pathname;
      const stgArticleshowURL =
        STAGING_URL_PREFIX2 + canonicalUrl[1].toLowerCase();
      if (
        canonicalUrl[1].toLowerCase() !== urlInBrowser.toLowerCase() &&
        stgArticleshowURL !== urlInBrowser.toLowerCase()
      ) {
        try {
          const searchString = window.location.href.split('?')[1];
          // history.push(canonicalUrl[1]);
          window.location.href = `${canonicalUrl[1]}${
            searchString ? `?${searchString}` : ''
          }`;
        } catch (e) {
          window.location.href = canonicalUrl[1];
        }
      }
    }
  }

  // Server Side redirection for the incorrect URL
  if (
    !isBrowser &&
    dataAvailable &&
    state.articleshow_v2.data[params.msid].seo
  ) {
    let canonicalUrl = state.articleshow_v2.data[params.msid].seo.canonical;

    if (typeof canonicalUrl === 'string') {
      const businessUsageType =
        state?.articleshow_v2?.data[params.msid]?.metaInfo?.BusinessUsageType;
      const isTOISpecialPage =
        businessUsageType && businessUsageType === 'Special Page';
      if (isTOISpecialPage) {
        canonicalUrl = canonicalUrl.replace('/articleshow/', '/featureshow/');
      }
    }

    let currentDomain = false;
    if (canonicalUrl.indexOf('timesofindia.indiatimes.com') > -1) {
      currentDomain = 'timesofindia.indiatimes.com';
    } else if (canonicalUrl.indexOf('toidev.indiatimes.com') > -1) {
      currentDomain = 'toidev.indiatimes.com';
    }

    if (
      canonicalUrl &&
      currentDomain &&
      pathname.indexOf('?') === -1 &&
      state.articleshow_v2.data[params.msid].multipublish !== 1
    ) {
      canonicalUrl = canonicalUrl.split(currentDomain);
      const urlPath = pathname;
      const stgArticleshowURL =
        STAGING_URL_PREFIX2 + canonicalUrl[1].toLowerCase();
      if (
        canonicalUrl[1].toLowerCase() !== urlPath.toLowerCase() &&
        stgArticleshowURL !== urlPath.toLowerCase()
      ) {
        let finalQueryString = '';
        if (Object.keys(context.query).length > 0) {
          const queryString = new URLSearchParams();
          Object.keys(context.query).forEach(key =>
            queryString.append(key, context.query[key]),
          );
          finalQueryString = queryString.toString();
          finalQueryString = `?${finalQueryString}`;
        }
        status = 301;
        redirect = `${TOI_LIVE_DOMAIN}${canonicalUrl[1]}${finalQueryString}`;
      }
    }
  }
  // OverRidelink redirection
  if (
    !isBrowser &&
    dataAvailable &&
    state.articleshow_v2.data[params.msid].seo
  ) {
    const hOverRidelink =
      state?.articleshow_v2?.data[params.msid]?.seo?.hOverRidelink;
    if (hOverRidelink) {
      status = 301;
      redirect = hOverRidelink;
    }
  }

  const atfFanAdData = getAtfFanAdCode();
  const footerFanAdData = getFbnFanAdCode();

  const getComponent = async pageTitle => {
    let returnHtml;
    if (dataAvailable) {
      const prebidObj = _get(
        state,
        `common.siteConfig.prebid.templates.articleshow`,
      );
      context.store.dispatch(updatePrebidFlag(prebidObj));
      const categoryForGA = 'WEB-Articleshow_V2';
      const rhsWidgetPriorityAS = _get(
        state,
        `common.siteConfig.rhsWidgetPriorityAS`,
        {},
      );
      const rhsWidgetVideoAS = _get(
        state,
        `common.siteConfig.rhsWidgetVideoAS.autoPlay`,
        '1',
      );
      const abTestCtnAdsId = _get(
        state,
        `common.siteConfig.abexperiment.ctnAds.experimentid`,
        '',
      );
      const abTestUpNextId = _get(
        state,
        `common.siteConfig.abexperiment.upnextsticky.experimentid`,
        '',
      );
      const scrollASHeight = _get(
        state,
        `common.siteConfig.abexperiment.upnextsticky.scrollHeight`,
        '',
      );
      const refreshTime = _get(
        state,
        `common.siteConfig.abexperiment.pagerefresh.refreshminutes.articleshow`,
        0,
      );
      const abAdskey = _get(
        state,
        `common.siteConfig.abexperiment.abAdskey`,
        '',
      );
      const forcePollShow = _get(
        state,
        `common.siteConfig.showASPollInsert`,
        '',
      );
      const abTestExperimentId = {
        abTestUpNextId,
        abTestCtnAdsId,
      };
      const isAdRemoved =
        state &&
        state.articleshow_v2 &&
        state.articleshow_v2.data &&
        state.articleshow_v2.data[params.msid] &&
        state.articleshow_v2.data[params.msid]?.metaInfo &&
        state.articleshow_v2.data[params.msid]?.metaInfo?.SpecialID &&
        state.articleshow_v2.data[params.msid]?.metaInfo?.SpecialID === 'noad';
      if (isBrowser) {
        window.categoryForGA = categoryForGA;
        window.categoryForSearchGA = 'WEB-Articleshow_V2';
        const secName = _get(
          state.articleshow_v2.data[params.msid],
          'navsubsecs.subsec2.subsecname2',
          '',
        );
        setAdsConfig({ subSection: secName.toLowerCase() });
      }

      const articleShowData =
        state &&
        state.articleshow_v2 &&
        state.articleshow_v2.data &&
        state.articleshow_v2.data[params.msid];
      /* code for SRA ads */
      if (_get(articleShowData, 'ads.dfp.experiment') === 'sra1') {
        newParams.delayTrackerAds = true;
        newParams.lazyloadRhsAds = true;
        newParams.lazyMobileBodyAds = true;
      }
      /* end code for SRA ads */

      const subSecSeoLocation =
        articleShowData.navsubsecs &&
        articleShowData.navsubsecs.subsec1 &&
        articleShowData.navsubsecs.subsec1.seolocation1;
      const electionFlag = _get(state, `common.siteConfig.showelection`);
      if (isCryptoCurrencyArticle) {
        showMiniTv = false;
        hideAdCude = true;
      }
      if (isAdRemoved) {
        hideAdCude = true;
        showMiniTv = false;
      }

      const topSearches =
        state.commonData && state.commonData?.data?.topSearches;
      const inFocusLinks =
        state.commonData && state.commonData?.data?.moreFrmEtimes;
      const loadPerpetualsInView = isExperimentEnabled(
        state,
        pathname,
        'articleshow',
        'loadPerpetualsInView',
      );
      returnHtml = (
        <Layout
          layoutClass="layout_type_2"
          title={pageTitle}
          params={newParams}
          query={Object.keys(context.query).length ? context.query : {}}
          layoutType=""
          hideStickyBackToTop
          rhs={false}
          adPosition="masthead"
          showMiniTv={showMiniTv}
          showAdBlockerInINEU
          showTimesTop10
          // hideAdBlockerDetector //comment this to add adblocker
          refreshFBNAd
          adsCampaignStatusUrl={_get(
            state.articleshow_v2.data[params.msid],
            `ads.dfp.info.MANAGE_AD_URL`,
          )}
          hideBreadcrumAtBottom
          hideAdCude={hideAdCude}
          pageType="ARTICLESHOW"
          pageTypeWithVersion="ARTICLESHOWV2"
          subSecSeoLocation={subSecSeoLocation}
          atfFanAdData={atfFanAdData}
          footerFanAdData={footerFanAdData}
          hideAds={isAdRemoved}
          showCovid19PopUp
          disablePopUpManager
          msid={newParams.msid}
          gutterAdCode={_get(
            state.articleshow_v2.data[params.msid],
            `ads.dfp.slots.OOP1`,
          )}
          // showTopSearchAtTop={
          //   topSearches && topSearches.items && topSearches.items.length
          // }
          hideAffiliatesFloatingNudge
          templateName={ARTICLESHOW}
          pathname={context.pathname}
        >
          <Articleshow
            isWapView={isWapView}
            isAppView={isAppView}
            msid={newParams.msid}
            query={Object.keys(context.query).length ? context.query : {}}
            // preloadedLeadImageHref={isMSPArticle ? leadImageHref : ''}
            isAdRemoved={isAdRemoved}
            params={newParams}
            electionFlag={electionFlag === '1'}
            categoryForGA={categoryForGA}
            abTestExperimentId={abTestExperimentId}
            abAdskey={abAdskey}
            refreshTime={parseFloat(refreshTime, 10)}
            scrollASHeight={scrollASHeight}
            rhsWidgetPriorityAS={rhsWidgetPriorityAS}
            rhsWidgetVideoAS={!!rhsWidgetVideoAS === '1'}
            location={context.pathname}
            isEtimesArticle
            topSearches={topSearches}
            isSPOTLIGHTArticle={isSPOTLIGHTArticle}
            forcePollShow={forcePollShow}
            loadPerpetualsInView={loadPerpetualsInView}
          />
          {inFocusLinks &&
            inFocusLinks.items &&
            inFocusLinks.items.length > 0 && (
              <div
                className={`${s.topsearches} ${s.topsearches_top} ${
                  state.isPrime || isAdRemoved ? s.topSearches_prime : ''
                }`}
                id="articlshow-topSearch"
              >
                <div className="contentwrapper">
                  <InfocusList
                    sectionData={{
                      ...inFocusLinks,
                      data: [...inFocusLinks.items],
                    }}
                    cssSelector="asEtimesFocusWdgt"
                    gaCategory={categoryForGA}
                    gaAction="click"
                    gaLabel="inFocusLinks"
                  />
                </div>
              </div>
            )}
        </Layout>
      );

      return returnHtml;
    }
    return (
      <div>
        Something went wrong. Click{' '}
        <a href="https://timesofindia.indiatimes.com">here</a> to browse TOI
      </div>
    );
  };

  const getMaxAge = () => {
    let maxAge = setCacheTime(state && state.isPrime);
    if (
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].maxAge
    ) {
      maxAge = state.articleshow_v2.data[params.msid].maxAge;
    }

    return maxAge;
  };

  const getEpaperLocation = () => {
    if (
      state &&
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].metaInfo
    ) {
      return state.articleshow_v2.data[params.msid].metaInfo?.eploc || '';
    }
    return '';
  };

  const getSeoData = async () => {
    const seoObj =
      state.articleshow_v2 && state.articleshow_v2.data
        ? _get(state.articleshow_v2.data[params.msid], 'seo', {})
        : {};

    const schemaObj =
      state.articleshow_v2 && state.articleshow_v2.data
        ? _get(state.articleshow_v2.data[params.msid], 'schema', [])
        : [];

    if (schemaObj && schemaObj.length > 0) {
      seoObj.schema = schemaObj;
    }
    seoObj.ogType = 'article';
    seoObj.article = true;
    seoObj.agencyName = _get(state, `articleshow_v2.data.${params.msid}.ag`);
    if (
      seoObj.agencyName &&
      (seoObj.agencyName === 'Mediawire' ||
        seoObj.agencyName === 'SPOTLIGHT' ||
        seoObj.agencyName === 'Spotlight Wire')
    ) {
      seoObj.noindexnofollow = true;
    }
    return seoObj;
  };

  const checkCoronaForSEO = data => {
    if (
      data &&
      data.title &&
      data.keywords &&
      (data.title.toLocaleLowerCase().indexOf('coronavirus') > -1 ||
        data.title.toLocaleLowerCase().indexOf('covid') > -1 ||
        data.keywords.toLocaleLowerCase().indexOf('coronavirus') > -1 ||
        data.keywords.toLocaleLowerCase().indexOf('covid') > -1)
    ) {
      return true;
    }
    return false;
  };
  const isMultipublish = () => {
    if (
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].multipublish
    ) {
      return true;
    }

    return false;
  };

  const getCategoryTabsMeta = () => {
    if (
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].story
    ) {
      const categoryNode = state.articleshow_v2.data[params.msid].story.filter(
        stry => stry?.tn === 'pollwidget',
      );
      return categoryNode &&
        Array.isArray(categoryNode) &&
        categoryNode.length > 0
        ? categoryNode[0]?.categorytabs
        : 'N/A';
    }

    return 'N/A';
  };

  const getGAConfig = async () => {
    let gaData = {};

    if (
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid]
    ) {
      gaData = getGAData(state.articleshow_v2.data[params.msid]);
    }
    const sectionsNameList = getSectionsListFromBreadCrumb(
      state.navigation && state.navigation.breadCrumbs
        ? state.navigation.breadCrumbs
        : [],
    );
    gaData.dimension8 = getCustomDimension8(sectionsNameList);

    const isCovidRelated =
      state &&
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].isCovid19Story;
    const coronaTextInSEOFeed =
      !isCovidRelated &&
      state &&
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].seo &&
      checkCoronaForSEO(state.articleshow_v2.data[params.msid].seo);
    if (isCovidRelated || coronaTextInSEOFeed) {
      gaData.dimension23 = 'Covid-19';
    }
    const isAutoIngested =
      state &&
      state.articleshow_v2 &&
      state.articleshow_v2.data &&
      state.articleshow_v2.data[params.msid] &&
      state.articleshow_v2.data[params.msid].metaInfo &&
      state.articleshow_v2.data[params.msid].metaInfo.AutoFeedIngestion;
    if (isAutoIngested === '1.0') {
      gaData.dimension27 = 'Auto Injested';
    }
    return gaData;
  };

  let adsTargetingObj = {};
  const layoutdata =
    state?.articleshow_v2?.data &&
    params?.msid &&
    state.articleshow_v2.data[params.msid];
  if (layoutdata) {
    const templateConfig = {
      Tmpl_SCN: 'Articleshow',
      Channel: 'etimes',
      isMobile: state.isMobile,
      pathname,
      articleId: params.msid,
      newkws: _get(layoutdata, 'newsKws', ''),
      kws: _get(layoutdata, 'seo.keywords', ''),
      specialId: _get(layoutdata, 'metaInfo.SpecialID'),
      navSubsecs: _get(layoutdata, 'navsubsecs', {}),
      jarvisConfig: _get(state, 'common.siteConfig.revenue', {}),
      dl: _get(layoutdata, 'dl', ''),
    };
    const { keyValueObj, newCaimpaignConfig } = processAdsCaimpaigns(
      templateConfig,
    );
    const feedkeys = _get(layoutdata, 'adstargetkeyVals', {});
    adsTargetingObj = {
      ...feedkeys,
      ...keyValueObj,
    };
    if (!isPrime && typeof window === 'undefined' && status === 200) {
      // Revenue Active or not
      context.store.dispatch(updateCaimpaignAdsConfig(newCaimpaignConfig));
      // Page Ads call
      await context.store.dispatch(loadPageAdCode(templateConfig));
      state = context.store.getState();
    }
  }

  if (isBrowser) {
    setValue({
      isAppView,
      isWapView,
      artData:
        state &&
        state.articleshow_v2 &&
        state.articleshow_v2.data &&
        state.articleshow_v2.data[params.msid],
      msid: params.msid,
    });
  }
  const gtmIDForOptimisely = ['GTM-54ZCD8R'];
  if (
    typeof window !== 'undefined' &&
    !isExperimentEnabled(state, pathname, 'articleshow', 'optimiseGA4PageView')
  ) {
    const categorytabsmeta = getCategoryTabsMeta();
    fireGA4Script({
      vmsid: params.msid,
      categorytabsmetainfo: categorytabsmeta,
    });
  }
  const afterAdsScript = [];
  if (isInstaEmbeds || context?.query?.incInstaEmbd) {
    afterAdsScript.push(TOI_INSTAGRAM_EMBED_JS);
  }

  const isAdRemoved =
    state &&
    state.articleshow_v2 &&
    state.articleshow_v2.data &&
    state.articleshow_v2.data[params.msid] &&
    state.articleshow_v2.data[params.msid]?.metaInfo &&
    state.articleshow_v2.data[params.msid]?.metaInfo?.SpecialID &&
    state.articleshow_v2.data[params.msid]?.metaInfo?.SpecialID === 'noad';

  const noAdArticle = state.isPrime || isAdRemoved;
  let sSjConf = null;

  if (!noAdArticle) {
    const webInterstitial = {
      cookExpireInhours: 1,
      skipInitialCall: true,
    };
    sSjConf = { webInterstitial };
  }
  const revWidgets = _get(state, 'revenue.data.widgets', {});

  let cwvReportingInfo = {};
  try {
    cwvReportingInfo = getCwvReportingObj({
      dataAvailable,
      state,
      platform: DESKTOP_PLATFORM,
      browsingPlatform: isAppView ? WEBVIEW_PLATFORM : DESKTOP_PLATFORM,
      businessProperty: BUSINESS_ETIMES,
    });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('issue in cwvReportingInfo');
    cwvReportingInfo = {};
  }

  return {
    chunks: [pageName],
    title,
    seoData: await getSeoData(),
    maxAge: getMaxAge(),
    gaData: await getGAConfig(),
    status,
    component: await getComponent(title),
    adsTargetingObj,
    preconnectDomains: ['//tpapi.timespoints.com'],
    multipublish: isMultipublish(),
    isMaxImagePreview: true,
    isMaxVideoPreview: false,
    shiftGutter: true,
    skipGpt: !isWapView,
    skipRouteAds: state.isPrime || isAdRemoved,
    removeThirdParty: isAdRemoved,
    addPersonaliseLib: true,
    // no ad scripts are required on msp articles, common commonHeadScripts and commonHeadScriptsMobile contain
    // only add related scripts as on 17 dec 2021
    // please update this check, if non ad related scripts are added too commonHeadScripts and commonHeadScriptsMobile
    // eslint-disable-next-line no-nested-ternary
    headTags:
      // eslint-disable-next-line no-nested-ternary
      isAdRemoved
        ? [
            ...commonHeadScripts,
            <script
              dangerouslySetInnerHTML={{
                __html: implementExperiment(),
              }}
            />,
          ]
        : isWapView
          ? [...commonHeadScriptsMobile]
          : [
              ...commonHeadScripts,
              <script
                dangerouslySetInnerHTML={{
                  __html: gptHeadAppendScript,
                }}
              />,
              <script
                dangerouslySetInnerHTML={{
                  __html: adRecoverScriptString,
                }}
              />,
              <script
                dangerouslySetInnerHTML={{
                  __html: implementExperiment(),
                }}
              />,
            ],
    skipPageViewGAOnLoad: true,
    gtmIDList: gtmIDForOptimisely,
    isPerfExperimented: true,
    useVariableFonts: true,
    inlineFirstFoldCSS: true,
    showPreload,
    imageInfo,
    redirect,
    useEtimesFavicon: true,
    edgeCacheTag: params.msid,
    eploc: getEpaperLocation() || '',
    xFrameOptions: true,
    afterAdsScript,
    enableInterstitial: !!sSjConf,
    jarvisAdsConfig: sSjConf,
    coreWebVitalPage: 'webvital_old_v1',
    isNewGam: _get(state, 'revenue.data.widgets.isNewGam', false),
    skipColumbiaScript: _get(state, 'revenue.data.widgets.skipCTN', false),
    addDebugBearScript: false,
    debugBearScript: null,
    extractAppState: isExperimentEnabled(
      state,
      pathname,
      'articleshow',
      'extractAppState',
    ),
    adsExperimentName: _get(revWidgets, 'adsExperimentName', ''),
    cwvReportingInfo,
    optimiseGA4PageView: isExperimentEnabled(
      state,
      pathname,
      'articleshow',
      'optimiseGA4PageView',
    ),
    ga4PageViewParams: getGa4PageViewEventObj(
      dataAvailable || {},
      {
        pageTemplate: 'articleshow',
        isMobile: state.isMobile,
        isPrime: state.isPrime,
        pagination: 'p0',
        perpetual: true,
        categorytabsmetainfo: getCategoryTabsMeta(),
        path: context.pathname,
      },
      state.isPrime ? { subs_experience_type: 'NEW_v1.3.0' } : {},
    ),
    loadResourcesOnBrowserIdle: isExperimentEnabled(
      state,
      pathname,
      'articleshow',
      'loadResourcesOnBrowserIdle',
    ),
  };
}

export default action;
